// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UwPZd1ahclnuW5 {
  vertical-align: text-top;
}
.wJUe954bBUtgo6 {
  margin: 8px 0;
}
.KSKsketgdAlsDs {
  margin: 4px 0;
}
.pst6Rhk13lI2oP {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}
.pst6Rhk13lI2oP .rkTO0B27VmHL7t {
  margin-right: 4px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerIcon": `UwPZd1ahclnuW5`,
	"divider": `wJUe954bBUtgo6`,
	"button": `KSKsketgdAlsDs`,
	"feedbackButton": `pst6Rhk13lI2oP`,
	"feedbackIcon": `rkTO0B27VmHL7t`
};
export default ___CSS_LOADER_EXPORT___;
